module.exports = __webpack_public_path__ + "img/laptop-with-arrow.fd9d452a.svg";